if (!customElements.get('sticky-atc-bar')) {
	customElements.define(
		'sticky-atc-bar',
		class StickyAtcBar extends HTMLElement {
			targetVisible = true;
			footerVisible = false;
			variantChangeUnsubscriber;
			targetObserver;
			footerObserver;

			connectedCallback() {
				this.sectionId = this.dataset.sectionId;
				this.mode = this.dataset.mode;
				this.targetSelector = this.dataset.targetSelector;
				this.button = this.querySelector('[data-sticky-atc-action]');

				this.button?.addEventListener('click', this.handleClick.bind(this));

				this.targetObserver = this.observe(this.targetSelector, (isIntersecting) => {
					this.targetVisible = isIntersecting;
					this.updateVisibility();
				});

				this.footerObserver = this.observe('.footer', (isIntersecting) => {
					this.footerVisible = isIntersecting;
					this.updateVisibility();
				});

				if (this.mode === 'cart') {
					this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
				}
			}

			disconnectedCallback() {
				this.targetObserver?.disconnect();
				this.footerObserver?.disconnect();
				this.variantChangeUnsubscriber?.();
				document.body.classList.remove('has-sticky-atc');
			}

			observe(selector, callback) {
				const target = document.querySelector(selector);
				if (!target) return undefined;

				const observer = new IntersectionObserver((entries) => callback(entries[0].isIntersecting));
				observer.observe(target);
				return observer;
			}

			updateVisibility() {
				const shouldShow = !this.targetVisible && !this.footerVisible;
				this.classList.toggle('sticky-atc-bar--visible', shouldShow);
				this.toggleAttribute('inert', !shouldShow);
				document.body.classList.toggle('has-sticky-atc', shouldShow);
			}

			handleClick(event) {
				event.preventDefault();
				const target = document.querySelector(this.targetSelector);
				if (!target) return;

				if (this.mode === 'personalize') {
					target.scrollIntoView({ behavior: 'smooth', block: 'center' });
					return;
				}

				target.click();
			}

			handleVariantChange({ data: { sectionId, variant } }) {
				if (sectionId !== this.sectionId) return;

				const sourcePrice = document.getElementById(`price-${sectionId}`);
				const destinationPrice = this.querySelector(`#StickyAtcPrice-${sectionId}`);
				if (sourcePrice && destinationPrice) {
					destinationPrice.innerHTML = sourcePrice.innerHTML;
				}

				if (!this.button) return;

				const isAvailable = Boolean(variant.available);
				this.button.toggleAttribute('disabled', !isAvailable);
				this.button.textContent = isAvailable
					? (window.variantStrings?.addToCart ?? this.button.textContent)
					: (window.variantStrings?.soldOut ?? this.button.textContent);
			}
		},
	);
}
